var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNpm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_19_134",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_19_134",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAzElEQVR4nGNgGAWjYBSMglHAwPB/gDEDiPjMwMBwHAc+C1XzFo+ay1A1z/CoQcefkR0AEsAFZKBqVuNRYwFV009CkjqOzwHeDAwMhQwMDDx4HBAOVYPPASlQDAKqUPVGxDhgFVRcBo8D4AbgccATKAaBUKiaolEHMFApClqQxAYkCpABxQ54xsDA0IeEb0LFZ0ExNgfkQy0E4eVQNWfRzPkMxSD2ZqiaA1D+M2QHEINx5QKKS0JiALaSEF6S0QP8p9QHo2AUjIJRMGgBAI11zwNyRl6fAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNpm);
export default __webpack_public_path__ + "static/media/LogoNPM.fd5098a769baccc87c4c4fea0024eb9f.svg";
export { ForwardRef as ReactComponent };